import { ShieldOff, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";

interface PermissionDeniedProps {
  requiredPermission?: string;
  message?: string;
}

export function PermissionDenied({
  requiredPermission,
  message,
}: PermissionDeniedProps) {
  const navigate = useNavigate();

  return (
    <div className="flex h-[60vh] items-center justify-center p-4">
      <Card className="mx-auto max-w-md">
        <CardHeader>
          <div className="flex items-center gap-2 text-destructive">
            <ShieldOff className="h-5 w-5" />
            <CardTitle className="text-lg">Permission denied</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            {message ??
              "You don't have permission to view this page. Ask an admin to grant access if you need it."}
          </p>
          {requiredPermission && (
            <p className="rounded bg-muted px-2 py-1 font-mono text-xs">
              Required: {requiredPermission}
            </p>
          )}
        </CardContent>
        <CardFooter className="gap-2">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
          <Button onClick={() => navigate("/pos")}>Go to POS</Button>
        </CardFooter>
      </Card>
    </div>
  );
}
